import { render } from "./TestConfigurationSetup.vue?vue&type=template&id=b72476c8&scoped=true"
import script from "./TestConfigurationSetup.vue?vue&type=script&lang=js"
export * from "./TestConfigurationSetup.vue?vue&type=script&lang=js"

import "./TestConfigurationSetup.vue?vue&type=style&index=0&id=b72476c8&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72476c8"]])

export default __exports__